module.exports = __webpack_public_path__ + "static/media/XXIIe.ab7b6e71.png";